import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/i18n";
import { setupUseInterceptors } from "./plugins/axios";
import VScrollSync from 'v-scroll-sync';
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "./assets/font-awesome/css/all.min.css";
import TextHighlight from 'vue-text-highlight';
import '@/plugins/vue2-google-maps';
import VueCookies from "vue-cookies-ts";
import "./registerServiceWorker";

Vue.config.productionTip = false;

Vue.use(VScrollSync);
Vue.use(VueCookies);
Vue.component('text-highlight', TextHighlight);

setupUseInterceptors(store, router);

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app");